"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function remove(_ref) {
  var blacklist = _ref.blacklist,
      state = _ref.state;
  return Object.keys(state).reduce(function (accumulator, current) {
    if (!blacklist.includes(current)) {
      accumulator[current] = state[current];
    }

    return accumulator;
  }, {});
}

var _default = remove;
exports["default"] = _default;